exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-select.v-select--chips.v-select--chips--small .v-select__selections{min-height:0!important}.v-label{font-size:14px!important}.v-select.v-select--chips input{min-height:42px}.v-btn__content{font-size:12px}.v-card{margin-top:0;margin-bottom:0}div.v-date-picker-table.v-date-picker-table--date.theme--light{height:unset!important;padding-bottom:4px}.v-date-picker-years li.active{color:#fff!important}", ""]);

// exports
